export default {
  RelgiousFamily: 1,
  CharediFamily: 2,
  TraditionalFamily: 3,
  SecularFamily: 6,
  Other: 7,
};
